import type { ReactNode } from 'react';

interface LeadFormTCPAProps {
  children: ReactNode;
  checkboxSlot?: ReactNode;
}

export function LeadFormTCPA({ children, checkboxSlot }: LeadFormTCPAProps) {
  return (
    <label style={{ display: 'block' }}>
      {/** biome-ignore lint/correctness/useUniqueElementIds: Jornaya/LeadiD requires this fixed DOM id for TCPA disclosure tracking */}
      <input
        type='hidden'
        id='leadid_tcpa_disclosure'
        name='Terms of Service'
      />
      {checkboxSlot}
      {children}
    </label>
  );
}
